'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue, useSetAtom } from 'jotai';

import { CompetitionStatusEnum } from '@flipster/apis/v2/trading-competition/types';
import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';

import { EventPeriod } from '../../component/event-period';
import { SeparatorTitle } from '../../component/separator-title';
import { competitionApiBunja, competitionTabsBunja } from '../../state';
import { BtcPriceCard } from './btc-price-card';
import { MyStatusCard } from './my-status-card';
import { predictionCardBunja } from './prediction-card.state';
import { pricePredictionBunja } from './state';
import { VotingCard } from './voting-card';

export const PricePredictionCard = () => {
  const { pricePredictionAtom, pricePredictionMeAtom } = useBunja(pricePredictionBunja);
  const { eventPeriodAtom } = useBunja(predictionCardBunja);
  const { scrollTargetRefAtom } = useBunja(competitionTabsBunja);
  const { competitionStatusAtom } = useBunja(competitionApiBunja);

  const prediction = useAtomValue(pricePredictionAtom);
  const me = useAtomValue(pricePredictionMeAtom);
  const eventPeriod = useAtomValue(eventPeriodAtom);
  const setScrollTargetRef = useSetAtom(scrollTargetRefAtom);
  const competitionStatus = useAtomValue(competitionStatusAtom);

  const isUpcoming = competitionStatus === CompetitionStatusEnum.Upcoming;
  const isRegistered = !!prediction?.participationTime;
  const showMyStatus = isRegistered && !isUpcoming;

  return (
    <section className={css(vstack.raw({ gap: 32, w: '100%' }), { scrollMarginTop: 100 })}>
      <div className={vstack({ w: '100%' })}>
        <SeparatorTitle
          colorSet='keyColor'
          subtitle={<FormattedMessage id='Campaign.r260123.Price_prediction_runs_once_a_day' />}
          title={<FormattedMessage id='Campaign.r260123.Bitcoin_today_up_or_down' />}
          description={<EventPeriod start={eventPeriod.start} end={eventPeriod.end} />}
        />
      </div>

      {showMyStatus && (
        <MyStatusCard
          priceDirection={me?.today?.predictionSide}
          volume={me?.today?.volume ?? '0'}
          expectedReward={{
            ifUpWins: me?.today?.estimatedReward?.ifUpWins ?? '0',
            ifDownWins: me?.today?.estimatedReward?.ifDownWins ?? '0',
          }}
        />
      )}

      <div
        ref={setScrollTargetRef}
        className={css({
          display: 'flex',
          flexDirection: { base: 'column', tablet: 'row' },
          gap: 24,
          w: '100%',
        })}
      >
        <BtcPriceCard />
        <VotingCard />
      </div>
    </section>
  );
};
